var map = {
	"./blog.yml": 52,
	"./cloud.yml": 53,
	"./color.yml": 54,
	"./country.yml": 55,
	"./dio.yml": 56,
	"./doc.yml": 57,
	"./emoji.yml": 58,
	"./git.yml": 59,
	"./icon.yml": 60,
	"./license.yml": 61,
	"./link.yml": 62,
	"./metrics.yml": 63,
	"./people.yml": 64,
	"./soft.yml": 65,
	"./src.yml": 66,
	"./status.yml": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;